<template>
	<span class="opacity-75">undefined</span>
</template>

<script>
export default {
	name: 'ArgUndefined',
}
</script>
